import moment from "moment"

// Event dates arrive as venue wall-clock strings with no offset
// ("2026-11-27 21:00:00"). moment parses the space-separated form every
// browser accepts (`new Date()` does not on Safari), and reading it back in the
// same zone it was parsed in gives the wall-clock time again wherever this
// runs — the server included.
//
// `Intl` does the wording rather than moment: moment's locale data is not
// bundled, so `.format("ddd DD MMM")` says "Fri 27 Nov" on a Spanish page
// whatever `.locale()` is set to.
const toDate = value => {
  if (!value) return null
  const parsed = moment.isMoment(value) ? value : moment(value)
  return parsed.isValid() ? parsed.toDate() : null
}

export const EVENT_DATE = { weekday: "short", day: "numeric", month: "short", year: "numeric" }

export const formatDate = (value, locale, options = EVENT_DATE) => {
  const date = toDate(value)
  return date ? date.toLocaleDateString(locale, options) : ""
}

// 24-hour on purpose: it is what the pages showed before, and the 12-hour
// suffix ("p.m." / "p. m.") is the part of the output that differs between the
// server's ICU data and the browser's, which would break hydration.
export const formatTime = (value, locale) => {
  const date = toDate(value)
  return date ? date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hourCycle: "h23" }) : ""
}

export const formatDateTime = (value, locale) => {
  const date = formatDate(value, locale)
  return date ? `${date} ${formatTime(value, locale)}` : ""
}
